export default __webpack_public_path__ + "static/media/CUBUS_0.22.e2170013.png";